import React, { useEffect, useMemo, useRef } from "react";
import OmokPage from "../OmokPage";
import { useDispatch, useSelector } from "react-redux";
import { doc, onSnapshot, setDoc } from "firebase/firestore";
import { changeMode, commonAction, updateBoard } from "../../slices/GameSlice";
import { db } from "../../firebase";
import WordGamePage from "../WordGamePage";
import { Search } from "../../Search";
import DavinciCodePage from "../davinciCode/DavinciCodePage";
import DragBoard from "../DragBoard";
import { footers } from "./Footers";
import LandminePage from "../landmine/LandminePage";
import {
  davinciCode,
  fakeCard,
  halligalli,
  landmine,
} from "../../util/gameDefault";
import HalligalliPage from "../halligalli/HalligalliPage";
import FakeCardPage from "../fakeCard/FakeCardPage";

const gameComponents = {
  오목: <OmokPage />,
  훈민정음: <WordGamePage />,
  끝말잇기: <WordGamePage />,
  다빈치코드: <DavinciCodePage />,
  지뢰찾기: <LandminePage />,
  할리갈리: <HalligalliPage />,
  페이크카드: <FakeCardPage />,
};

const ContentPage = () => {
  const { gameMode, roomId, searchWord } = useSelector(
    state => state.GameSlice
  );

  // const { userId, nickname } = useSelector(state => state.LoginInfoSlice);

  const dispatch = useDispatch();
  const modeRef = useRef();
  const consotantRef = useRef("");

  useEffect(() => {
    if (searchWord) {
      const getResults = async () => {
        try {
          const results = await Search(searchWord).then(r => r.item);
          const item = results.filter(
            i => i.word?.replaceAll("-", "") === searchWord
          );
          const maps = item?.map(i => i?.sense[0]);
          dispatch(commonAction({ target: "searchResults", value: maps }));
        } catch {}
      };

      getResults();
    }
  }, [dispatch, searchWord]);

  useEffect(() => {
    if (roomId) {
      const docRef = doc(db, "game", `room${roomId}`);
      const unsubscribe = onSnapshot(docRef, async querySnapshot => {
        if (querySnapshot.exists()) {
          const {
            board: boardArr,
            gameMode,
            wordMatchs,
            initialConsonant,
            users,
            davinciCode,
            landmine,
            halligalli,
            fakeCard,
          } = querySnapshot.data();
          if (consotantRef.current !== initialConsonant) {
            dispatch(
              commonAction({
                target: "initialConsonant",
                value: initialConsonant,
              })
            );
            consotantRef.current = initialConsonant;
          }
          dispatch(commonAction({ target: "users", value: users }));
          if (modeRef.current !== gameMode) {
            modeRef.current = gameMode;
            dispatch(changeMode({ gameMode }));
          }

          switch (gameMode) {
            case "오목":
              dispatch(updateBoard({ boardArr }));
              break;
            case "훈민정음":
              const lastWord = wordMatchs[wordMatchs.length - 1]?.word;
              dispatch(commonAction({ target: "searchWord", value: lastWord }));
              dispatch(
                commonAction({ target: "wordMatchs", value: wordMatchs })
              );
              break;
            case "다빈치코드":
              dispatch(
                commonAction({ target: "davinciCode", value: davinciCode })
              );
              break;
            case "지뢰찾기":
              dispatch(commonAction({ target: "landmine", value: landmine }));
              break;
            case "할리갈리":
              dispatch(
                commonAction({ target: "halligalli", value: halligalli })
              );
              break;

            case "페이크카드":
              dispatch(commonAction({ target: "fakeCard", value: fakeCard }));
              break;
            default:
              break;
          }
        } else {
          try {
            const userId = localStorage.getItem("id");
            const nickname = localStorage.getItem("nickname");
            await setDoc(docRef, {
              message: [],
              board: [],
              gameMode: "다빈치코드",
              wordMatchs: [],
              epilogueMatchs: [],
              initialConsonant: "",
              davinciCode,
              landmine,
              halligalli,
              fakeCard,

              users: [{ userId, nickname, order: 0 }],
            }); // 초기 데이터 설정
          } catch (e) {
            console.error("Error creating document: ", e);
          }
        }
      });

      return () => {
        modeRef.current = null;
        unsubscribe();
      };
    }
  }, [dispatch, roomId, gameMode]);

  const size = useMemo(() => {
    const boardSize = {
      다빈치코드: { width: "433px", height: "489px" },
      할리갈리: { width: "361px", height: "313px" },
      지뢰찾기: { width: "385px", height: "432px" },
      훈민정음: { width: "365px", height: "520px" },
      오목: { width: "457px", height: "504px" },
      페이크카드: { width: "457px", height: "504px" },
    };
    return boardSize[gameMode];
  }, [gameMode]);

  return (
    <DragBoard
      left={0}
      minHeight={"300px"}
      defaultSize={size || { width: "400px", height: "400px" }}
      zIndex={1}
      footerContents={footers[gameMode]}>
      {gameComponents[gameMode]}
    </DragBoard>
  );
};
export default ContentPage;
